module.exports = __webpack_public_path__ + "img/slika9.136ef7a4.jpg";